import { render, staticRenderFns } from "./RehinBelgesiAlacakForm.vue?vue&type=template&id=8f4905aa"
import script from "./RehinBelgesiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./RehinBelgesiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports